import script from "./LandingPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./LandingPage.vue?vue&type=script&lang=ts&setup=true"

import "./LandingPage.vue?vue&type=style&index=0&id=7270fee0&lang=scss&scoped=true"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7270fee0"]])

export default __exports__